import { isAgentPortal } from "js/utilities";
import { Trans } from "react-i18next";
import { Link } from "react-router-dom";
const ViewMoreSlideDetail = () => {
  return (
    <>
      <Trans
        i18nKey={
          isAgentPortal()
            ? "AgentCarouselAlerts-correspondence-Alerts"
            : "CustomerCarouselAlerts-correspondence-Alerts"
        }
        components={{
          Link1: <Link to="/messages"></Link>,
        }}
      ></Trans>
    </>
  );
};

export const viewMoreSlide = {
  iconBorder: "ui-icon-border-good",
  detail: <ViewMoreSlideDetail />,
};
